import { render, staticRenderFns } from "./CommodityFilters.vue?vue&type=template&id=07b44324&"
import script from "./CommodityFilters.vue?vue&type=script&lang=js&"
export * from "./CommodityFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports